// extracted by mini-css-extract-plugin
module.exports = {"name":"_7a3fb80146--name--kvG5Z"};